import React from "react";
import { FaEnvelope, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { indiaSupport } from "../../content/indiaSiteContent";

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  const handleScrollToContact = () => {
    const target = document.getElementById("support-contact-form");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="relative overflow-hidden bg-brand-dark pb-20 pt-32 md:pb-32 md:pt-48">
      <div className="absolute inset-0 opacity-40">
        <img
          src="/2.jpg"
          alt="travel background"
          className="h-full w-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/60 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <span className="mb-6 inline-block rounded-full border border-brand-pink/30 bg-brand-pink/20 px-3 py-1 text-sm font-semibold uppercase tracking-wider text-brand-pink">
          {t("24/7 Customer Assistance")}
        </span>

        <h1 className="mb-6 font-heading text-4xl font-bold leading-tight text-white md:text-6xl lg:text-7xl">
          How can we
          <span className="italic text-brand-pink"> help you?</span>
        </h1>

        <p className="mx-auto mb-10 max-w-2xl text-lg text-gray-300 md:text-xl">
          {t("Reach our holiday and visa support team on WhatsApp, phone, or email whenever you need assistance.")}
        </p>

        <div className="mb-10 flex flex-wrap justify-center gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-white">
            <FaWhatsapp className="text-brand-pink" />
            {indiaSupport.whatsappDisplay}
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-white">
            <FaPhoneAlt className="text-brand-pink" />
            {indiaSupport.phoneDisplay}
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-white">
            <FaEnvelope className="text-brand-pink" />
            {indiaSupport.email}
          </span>
        </div>

        <button
          type="button"
          onClick={handleScrollToContact}
          className="rounded-full bg-brand-pink px-8 py-4 font-medium text-white transition-colors hover:bg-brand-pink/90"
        >
          {t("Contact Support")}
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
